import { Box } from "@chakra-ui/layout"
import React from "reactn"
import { BlockCard } from "./block-card"

export function BlockListing({ seo, location, isStory, eager, blocks = [] }) {
  return (
    <Box id="blocksListing"
      w={"100%"}
    >
      {blocks.map((b, i) => (
        <Box key={`bl${i}`}>
          <BlockCard blockCard={b} isStory={isStory} eager={eager} seo={seo} location={location} />
        </Box>
      ))}
    </Box>
  )
}
